import type { ToolMeta } from "../types";

export const toolMeta = {
  slug: "image-converter",
  title: "Image Converter",
  description:
    "Convert images to JPG, PNG, WebP, or PDF directly in the browser with batch controls and downloads.",
  category: "Images",
} satisfies ToolMeta;
